<template>
  <div class="overlay filter-mobile" v-if="showModal">
    <div class="modal-card  is-gapless">
      <header class="modal-card-title">
        {{ $t('filter.advanced_filter') }}
        <BIcon icon="close" class="img-close" @click.native="$emit('hide')"> </BIcon>
      </header>
      <section class="modal-card-body">
        <div class="columns not-margin is-mobile is-centered">
          <div class="column m is-12">
            <div class="modal-card-subtitle">{{ $t('filter.tournament') }}:</div>
            <BField>
              <BSelect placeholder="Filtros" :value="seasonId" @input="onSeasonChanged" expanded size="is-medium">
                <option v-for="season in seasons" :key="season.id" :value="season.id">
                  {{ season.name }}
                </option>
              </BSelect>
            </BField>
          </div>
        </div>
        <div class="columns not-margin is-mobile is-centered">
          <div class="column m is-12">
            <div class="modal-card-subtitle">{{ $t('filter.locality') }}:</div>
            <BField>
              <BSelect v-model="playingAs" expanded @input="onPlayingAsChanged" size="is-medium">
                <option v-for="(playing, index) in playingType" :key="index" :value="playing.playingAs">
                  {{ $t(playing.label) }}
                </option>
              </BSelect>
            </BField>
          </div>
        </div>
        <div class="columns not-margin is-mobile is-centered">
          <div class="column m is-12 m-medium-checks">
            <div class="modal-card-subtitle">{{ $t('filter.results') }}:</div>
            <div :key="resultsKey" class="checkbox-group">
              <div class="field">
                <BCheckbox :native-value="1" v-model="results">{{ $t('filter.won') }}</BCheckbox>
              </div>
              <div class="field">
                <BCheckbox :native-value="3" v-model="results">{{ $t('filter.tied') }}</BCheckbox>
              </div>
              <div class="field">
                <BCheckbox :native-value="2" v-model="results">{{ $t('filter.lost') }}</BCheckbox>
              </div>
            </div>
          </div>
          <div class="column not-padding m is-12 m-small-checks">
            <div class="modal-card-subtitle">{{ $t('filter.results') }}:</div>
            <div :key="resultsKey" class="checkbox-group">
              <div class="field">
                <BCheckbox :native-value="1" v-model="results" size="is-small">{{ $t('filter.won') }}</BCheckbox>
              </div>
              <div class="field">
                <BCheckbox :native-value="3" v-model="results" size="is-small">{{ $t('filter.tied') }}</BCheckbox>
              </div>
              <div class="field">
                <BCheckbox :native-value="2" v-model="results" size="is-small">{{ $t('filter.lost') }}</BCheckbox>
              </div>
            </div>
          </div>
        </div>
        <!-- Games -->
        <div class="columns not-margin is-mobile is-centered">
          <div class="column m is-12 ">
            <div class="modal-card-subtitle">{{ $t('filter.games') }}:</div>
            <BField>
              <BDropdown aria-role="list" :close-on-click="false" scrollable expanded :disabled="!this.selectedGames">
                <template #trigger>
                  <div class="filter-item__games selected">
                    <div class="text">{{ selectedGamesText }}</div>
                    <div class="icn-arrow">
                      <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down.svg" alt="" />
                    </div>
                  </div>
                </template>
                <BDropdownItem v-for="game of availableGames" :value="game.id" :key="game.id" aria-role="listitem">
                  <div class="available-game" @click.stop="onAvailableGameClicked">
                    <div>
                      <BCheckbox class="vertical-align-middle" v-model="game.isSelected">
                        {{ `${game.roundAbbreviation} vs ${game.rivalTeam.colloquial_name}` }}
                      </BCheckbox>
                    </div>
                  </div>
                </BDropdownItem>
              </BDropdown>
            </BField>
          </div>
        </div>
        <div class="columns not-margin not-border is-centered">
          <div class="column is-12">
            <div class="modal-card-subtitle">{{ $t('filter.time_lapse') }}</div>
            <div :key="sectionsKey" class="columns not-border not-margin is-mobile is-centered m-medium-btn">
              <div class="column is-6 is-centered">
                <div class="btn-group">
                  <BField>
                    <BCheckboxButton :native-value="1" v-model="sections">
                      <span class="value-hidden">0</span>0-15
                    </BCheckboxButton>
                    <BCheckboxButton :native-value="2" v-model="sections">
                      16-30
                    </BCheckboxButton>
                    <BCheckboxButton :native-value="3" v-model="sections">
                      31-45
                    </BCheckboxButton>
                  </BField>
                </div>
              </div>
              <div class="column is-6 is-centered">
                <div class="btn-group">
                  <BField>
                    <BCheckboxButton :native-value="4" v-model="sections">
                      46-60
                    </BCheckboxButton>
                    <BCheckboxButton :native-value="5" v-model="sections">
                      61-75
                    </BCheckboxButton>
                    <BCheckboxButton :native-value="6" v-model="sections">
                      76-90
                    </BCheckboxButton>
                  </BField>
                </div>
              </div>
            </div>
            <div :key="sectionsKey" class="columns not-border not-margin is-centered m-small-btn">
              <div class="column not-border is-6 is-centered">
                <div class="btn-group">
                  <BField>
                    <BCheckboxButton :native-value="1" v-model="sections">
                      <span class="value-hidden">0</span>0-15
                    </BCheckboxButton>
                    <BCheckboxButton :native-value="2" v-model="sections">
                      16-30
                    </BCheckboxButton>
                    <BCheckboxButton :native-value="3" v-model="sections">
                      31-45
                    </BCheckboxButton>
                  </BField>
                </div>
              </div>
              <div class="column is-6 is-centered">
                <div class="btn-group">
                  <BField>
                    <BCheckboxButton :native-value="4" v-model="sections">
                      46-60
                    </BCheckboxButton>
                    <BCheckboxButton :native-value="5" v-model="sections">
                      61-75
                    </BCheckboxButton>
                    <BCheckboxButton :native-value="6" v-model="sections">
                      76-90
                    </BCheckboxButton>
                  </BField>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="filter-item">
            <BButton type="is-primary" class="btn-is-primary" @click="$emit('hide')">{{
              $t('general.accept')
            }}</BButton>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    sections: [1, 2, 3, 4, 5, 6],
    results: [1, 2, 3],
    playingAs: null,
    availableGames: [],
    playingType: [
      {
        playingAs: null,
        label: 'filter.all',
      },
      {
        playingAs: 1,
        label: 'filter.home',
      },
      {
        playingAs: 2,
        label: 'filter.away',
      },
    ],
    resultsKey: 0,
    sectionsKey: 0,
  }),
  watch: {
    '$route.name': {
      immediate: true,
      handler(newValue) {
        let analysisType = 0;
        let teamId = 0;
        if (newValue === 'player') {
          analysisType = 1;
          teamId = 0;
        } else {
          analysisType = 2;
          teamId = Number(this.$route.params.teamId);
        }
        this.setAnalysisType(analysisType);
        this.setTeamId(teamId);
      },
    },
    games(newValue) {
      this.availableGames = [...newValue] || [];
      this.fillSelectedGames();
    },
    showModal() {
      this.setSections();
      this.setResults();
    },
    sections(newValue, oldValue) {
      if (newValue.length === 0) {
        this.sections = oldValue;
        this.sectionsKey++;
      }
      this.setSections();
    },
    results(newValue, oldValue) {
      if (newValue.length === 0) {
        this.results = oldValue;
        this.resultsKey++;
      }
      this.setResults();
    },
    playingAs() {
      this.setPlayingAs();
    },
  },
  computed: {
    ...mapGetters('filterGeneral', {
      seasons: 'getSeasons',
      seasonId: 'getSeasonId',
      stadisticId: 'getStadisticId',
      games: 'availableGames',
      isPlayerNationalTeam: 'isPlayerNationalTeam',
    }),
    selectedGames() {
      return this.availableGames.reduce((accumulator, game) => {
        if (game.isSelected) {
          // eslint-disable-next-line no-param-reassign
          accumulator++;
        }
        return accumulator;
      }, 0);
    },
    selectedGamesText() {
      if (this.selectedGames === 1) {
        const activeGame = this.availableGames.find(game => game.isSelected);
        return `${activeGame.roundAbbreviation} vs ${activeGame.rivalTeam.colloquial_name}`;
      } else if (!this.selectedGames) {
        return `partidos no disponibles`;
      }
      return `${this.selectedGames} ${this.$t('filter.selected')}`;
    },
  },
  methods: {
    ...mapMutations('filterGeneral', ['setAnalysisType', 'setSelectedGamesIds', 'setTeamId']),
    /**
     * @author José Rafael Gutierrez
     * Set property sections in filterGeneral module.
     * @return void
     */
    setSections() {
      this.$store.commit('filterGeneral/setSections', this.sections);
      this.$emit('sectionsChanged', this.sections);
    },
    /**
     * @author José Rafael Gutierrez
     * Set property results in filterGeneral module.
     * @return void
     */
    setResults() {
      try {
        this.$store.commit('filterGeneral/setResults', this.results);
        this.$emit('resultsChanged', this.results);
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * @author José Rafael Gutierrez
     * Set property playingAs in filterGeneral module.
     * @return void
     */
    setPlayingAs() {
      try {
        this.$store.commit('filterGeneral/setPlayingAs', this.playingAs);
      } catch (err) {
        console.error(err);
      }
    },
    fillSelectedGames() {
      const selectedGamesIds = this.availableGames.reduce((accumulator, game) => {
        if (game.isSelected) {
          accumulator.push(game.id);
        }
        return accumulator;
      }, []);
      this.setSelectedGamesIds(selectedGamesIds);
    },
    onAvailableGameClicked() {
      setTimeout(() => {
        this.fillSelectedGames();
      }, 100);
    },
    onSeasonChanged(value) {
      if (this.$store.getters['filterGeneral/getSeasonId'] !== value) {
        this.$store.commit('filterGeneral/setSeasonId', value);
        const selectedSeason = this.seasons.find(season => season.id === value);
        if (selectedSeason) {
          this.$store.commit('filterGeneral/setSeasonType', selectedSeason.type);
        }
      }
    },
    /**
     * @author Cristhian Gómez
     * Set property stadisticId in filterGeneral module.
     * @return void
     */
    onStadisticChanged(value) {
      this.$store.commit('filterGeneral/setStadisticId', value);
      this.$emit('statisticsChanged', value);
    },
    onPlayingAsChanged(value) {
      let type = this.playingType.find(p => p.playingAs == value).label;
      this.$emit('playingAsChanged', type);
    },
  },
  created() {
    this.playingAs = this.playingType[0].playingAs;
  },
};
</script>

<style lang="scss" scoped>
.not-margin {
  margin: 0 !important;
}
.checks {
  justify-content: space-around;
  border-bottom: none !important;
  margin-right: 0px !important;
  flex-wrap: wrap;
}
.value-hidden {
  visibility: hidden;
}
.checkbox-group {
  display: flex;
  height: 48px;
  justify-content: space-evenly;
  font-family: Avenir-Medium;
  align-items: center;
  margin: 6px 1px 0 2px;
  padding: 10px 4px 2px 4px;
  border-radius: 8px;
  flex-wrap: wrap;
  border: solid 1px #b4b4b4;
  .field:not(:last-child) {
    margin-bottom: 0px;
  }
  .b-checkbox.checkbox input[type='checkbox'] + .check {
    border: 2px solid #d3d3d3;
  }
}
.btn-is-primary {
  padding: 20px 40px;
  font-family: Avenir-Demi;
  font-size: 18px;
  font-style: normal;
  line-height: 0.79;
  text-align: center;
  color: #ffffff;
}
.columns {
  padding: 6px 0px;
  .is-centered {
    width: 100%;
    border-bottom: solid 1px #b4b4b4;
  }
}
.overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: flex-end;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-card {
  height: 90%;
  width: 100%;
  padding: 0px;
  margin: 0px;
  background-color: #f9f9f9;
  border-radius: 24px 24px 0px 0px;
}
.modal-card-body {
  padding: 0px 30px;
  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.07);
  background-color: #f3f3f3;
}
.modal-card-title {
  width: 100%;
  height: 80px;
  line-height: 40px;
  padding: 25px 0px;
  font-family: 'Avenir-Demi';
  flex-shrink: 1;
  flex-grow: 0;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #6f6f6f;

  .img-close {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }
}
.modal-card-subtitle {
  font-family: 'Avenir-Demi-Medium';
  font-size: 14px;
  padding-bottom: 5px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.04px;
  color: #494a4b;
  text-align: left;
  text-transform: capitalize;
}
.button-group {
  display: flex;
  justify-content: space-evenly;
  .btn-letter {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: solid 1px #4e4e4e;
    background-color: #ffffff;
    width: 35px;
    height: 35px;
    border: solid 1px #4e4e4e;
    background-color: #ffffff;
    font-family: Circular-Std;
    font-size: 20px;
    text-align: center;
    color: #494a4b;
    font-weight: bold;
    outline: none;

    &:hover {
      background-color: #cce8b5;
    }
  }
}
.btn-group-pair {
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    width: 80px;
    height: 36px;
    border-radius: 6px;
    background-color: #fdfdfd;
    border: solid 1px #4e4e4e;
    font-family: Circular-Std;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.05px;
    text-align: center;
    color: #494a4b;

    &:hover {
      background-color: #adadad;
    }
    &:first-child {
      border-radius: 6px 0px 0px 6px;
    }
    &:last-child {
      border-radius: 0px 6px 6px 0px;
    }
  }
}
.btn-group {
  display: flex;
  justify-content: space-evenly;
  button {
    width: 58px;
    height: 40px;
    font-family: 'Circular-Std-Medium';
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.04px;
    text-align: center;
    color: #494a4b;
    border: solid 1px #4e4e4e;

    &:hover {
      background-color: #cce8b5;
    }
  }
  button:first-child {
    border-radius: 6px 0px 0px 6px;
  }
  button:last-child {
    border-radius: 0px 6px 6px 0px;
  }
}
button {
  outline: none;
  cursor: pointer;
}
.not-border {
  border: 0px !important;
  border-bottom: 0px solid gray !important;
}
.not-padding {
  padding: 10px 0px !important;
}
.m-small-checks,
.m-small-btn {
  display: none;
}
@media screen and (max-width: 520px) {
  .m-medium-checks,
  .m-medium-btn {
    display: none;
  }
  .m-small-checks,
  .m-small-btn {
    display: inline-block;
  }
}

.selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-radius: 4px;
  border: solid 1px #dbdbdb;
  padding: 0.5em 1.4em 0.5em 0.8em;
  cursor: pointer;
  white-space: nowrap;

  & > .icn-arrow {
    margin-left: 0.6em;
  }
}

.available-game {
  width: 100%;
  display: flex;
  justify-content: flex-start;

  & > div {
    min-width: 155px;
    display: flex;
    justify-content: flex-start;
  }
}
</style>

<style lang="scss">
.overlay > div.modal-card {
  & a.dropdown-item {
    padding: 0.375rem 0.2rem;
  }

  & .dropdown-item.is-active,
  .dropdown .dropdown-menu .has-link a.is-active,
  button.dropdown-item.is-active {
    background-color: white;
    color: #4a4a4a;
  }

  @media screen and (max-width: 1023px) {
    .dropdown.is-mobile-modal > .dropdown-menu {
      position: absolute !important;
      width: 100%;
      max-height: calc(100vh - 120px);
      bottom: unset !important;
      top: 100% !important;
      left: 0 !important;
      right: unset !important;
      z-index: 50 !important;
      transform: unset !important;
    }

    .dropdown-content {
      background-color: white;
      border-radius: 4px;
      -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1) !important;
      box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1) !important;
      padding-bottom: 0.5rem;
      padding-top: 0.5rem;
      border: solid 1px #dbdbdb;
    }

    .dropdown.is-mobile-modal > .dropdown-menu > .dropdown-content > .dropdown-item,
    .dropdown .dropdown-menu .has-link .dropdown.is-mobile-modal > .dropdown-menu > .dropdown-content > a,
    .dropdown.is-mobile-modal > .dropdown-menu > .dropdown-content > .has-link a {
      padding: 0.375rem 0.2rem;
    }
  }

  .dropdown.is-expanded.is-mobile-modal .dropdown-menu {
    max-width: max-content !important;
  }

  .dropdown .background {
    display: none !important;
  }
}

div.overlay.filter-mobile {
  & div.dropdown-content {
    width: 100%;
  }

  & > .modal-card div.dropdown-content {
    width: 100%;
  }

  & > .modal-card .dropdown.is-expanded.is-mobile-modal .dropdown-menu {
    max-width: 100% !important;
  }
}
</style>
